import UnassignedJourneyCard from './component';
import { compose, withHandlers } from 'recompose';

const enhance = compose(
  withHandlers({
    onCardClick:
      ({ onClick, journeyId }) =>
      () => {
        onClick(journeyId);
      },
  })
);

export default enhance(UnassignedJourneyCard);
